module.exports = __webpack_public_path__ + "static/media/blue-gradation-bkgd-dots-desktop1440.8830e951.png";